<button
  *ngIf="patientId"
  class="btn btn-primary"
  type="button"
  (click)="addFrameToCart()"
  [disabled]="isButtonDisabled"
>
  Add to <br />My Favorites
</button>
